import type { Reducer } from 'redux';
import { produce } from 'immer';
import type { CompanyRequestedForDeletionActions } from './types/actions.types';
import { defaultState, Fields } from './data/CompanyRequestedForDeletionState';
import CompanyRequestedForDeletionConstants from './constants';

const reducer: Reducer<Fields, CompanyRequestedForDeletionActions> = (
  state = defaultState,
  action
) => {
  return produce<Fields>(state, (draft) => {
    switch (action.type) {
      case CompanyRequestedForDeletionConstants.REMOVE_COMPANY_DELETION_REQUEST_REQUEST:
        draft.isRemovingDeletionRequest = true;
        return draft;

      case CompanyRequestedForDeletionConstants.REMOVE_COMPANY_DELETION_REQUEST_REQUEST_SUCCESS:
      case CompanyRequestedForDeletionConstants.REMOVE_COMPANY_DELETION_REQUEST_REQUEST_ERROR:
        draft.isRemovingDeletionRequest = false;
        return draft;

      case CompanyRequestedForDeletionConstants.GET_COMPANY_DELETION_REQUEST_STATUS_REQUEST_SUCCESS:
        draft.isCompanyRequestedForDeletion = action.response;
        return draft;

      default:
        return state;
    }
  });
};

export default reducer;
